var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M8.33333 13.3334H5.83333C3.99239 13.3334 2.5 11.841 2.5 10V10C2.5 8.15907 3.99238 6.66669 5.83333 6.66669H8.33333",
    stroke: "#61616F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M13.3337 10H6.66699",
    stroke: "#61616F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M11.6667 13.3334H14.1667C16.0076 13.3334 17.5 11.841 17.5 10V10C17.5 8.15907 16.0076 6.66669 14.1667 6.66669H11.6667",
    stroke: "#61616F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.58221d9699ed9e1b9f7bd13d9e82679f.svg";
export { ForwardRef as ReactComponent };